<!--one3d-car-exchange-wrapper starts here-->
<!-- <div class="one3d-car-exchange-wrapper"> -->
<configurator-header></configurator-header>
<ion-content scrollY="false">
  <div class="one3d-content-header one3d-custom-border-bottom">
    <h1 class="one3d-content-header-title">{{'CAR_EXCHANGE.TRADE_IN_CALCULATOR' | translate}}</h1>
    <button (click)="closeCarExchange()">
      <span
        ><img src="assets/img/icons/one3d-close-icon.svg" alt="close page icon"
      /></span>
    </button>
  </div>
  <div class="one3d-scrollable-wrapper-custom one3d-trade-in-calculator-wrap">
    <iframe
      *ngIf="loadIframe && !showCalculation"
      [src]="iframeUrl | safe"
      width="100%"
      id="carExchange"
      height="100%"
    ></iframe>
    <!-- <div class="estimated-value-car-wrapper">
     <ion-text>
       The Estimated value of car exchange would be around <strong> 1,25,000</strong> 
      </ion-text> 
    </div> -->
    <div
      *ngIf="showCalculation"
      class="one3d-view-added-accessories-box-wrap one3d-emi-sections"
    >
      <ion-row class="one3d-view-added-accessories-row">
        <ion-col size="6">
          <h4 class="one3d-emi-variant-title" translate>CAR_EXCHANGE.MODEL</h4>
        </ion-col>
        <ion-col size="6" class="one3d-summary-content-right-col">
          <span class="one3d-summary-descriptor-value one3d-emi-showroom-text">
            {{ carExchange?.MakeBrand }}
          </span>
        </ion-col>
      </ion-row>
      <ion-row class="one3d-view-added-accessories-row">
        <ion-col size="6">
          <h4 class="one3d-emi-variant-title" translate>CAR_EXCHANGE.VARIANT</h4>
        </ion-col>
        <ion-col size="6" class="one3d-summary-content-right-col">
          <span class="one3d-summary-descriptor-value one3d-emi-showroom-text">
            {{ carExchange?.MakeVariant }}
          </span>
        </ion-col>
      </ion-row>
      <ion-row
        class="one3d-view-added-accessories-row one3d-custom-border-bottom one3d-last-row"
      >
        <ion-col size="6">
          <h4 class="one3d-emi-variant-title" translate>CAR_EXCHANGE.YEAR</h4>
        </ion-col>
        <ion-col size="6" class="one3d-summary-content-right-col">
          <span class="one3d-summary-descriptor-value one3d-emi-showroom-text">
            {{ carExchange?.MakeYear }}
          </span>
        </ion-col>
      </ion-row>
      <ion-row
        class="one3d-view-added-accessories-row one3d-custom-border-bottom"
      >
        <ion-col size="6">
          <h4 class="one3d-emi-variant-title one3d-uppercase">
            {{'CAR_EXCHANGE.APPROXIMATE_EXCHANGE_VALUE' | translate}}
          </h4>
        </ion-col>
        <ion-col size="6" class="one3d-summary-content-right-col">
          <span class="one3d-summary-descriptor-value one3d-emi-showroom-text">
            <strong>
              {{
                globalService.currencyFormatter(carExchange?.MinimumValue)
              }}</strong
            >
          </span>
        </ion-col>
      </ion-row>

      <ion-row class="one3d-view-added-accessories-row">
        <ion-col
          size-xl="12"
          size-lg="12"
          size-md="12"
          size="12"
          class="one3d-explore-finance-option-col one3d-explore-finance-option"
        >
          <ion-button
            class="one3d-explore-finance-option-btn"
            color="dark"
            shape="round"
            fill="outline"
            (click)="editValues()"
          >
          {{'CAR_EXCHANGE.EDIT_VALUES' | translate}}
          </ion-button>
        </ion-col>
      </ion-row>
    </div>

    <div class="one3d-discalaimer-section">
      <div class="one3d-disclamier-btn-wrapper">
        <button class="one3d-discalaimer-btn">
          <span>
            <ion-icon name="alert-circle-outline"></ion-icon>
          </span>
          <span>{{'CAR_EXCHANGE.DISCLAIMER' | translate}}</span>
        </button>
      </div>
      <div class="one3d-discalaimer-content">
        <div class="one3d-discalaimer-close ion-text-end">
          <ion-icon name="close"></ion-icon>
        </div>
        <p class="one3d-discalaimer-content-para">
          *{{'CAR_EXCHANGE.DISCLAIMER_NOTE' | translate}}.
        </p>
      </div>
    </div>

    <div
      *ngIf="showCalculation"
      class="one3d-lhs-config-bottom-wrapper one3d-placeAtBottom"
    >
      <ion-row class="one3d-lhs-config-btn-row">
        <ion-col class="ion-no-padding" size="6">
          <ion-button
            (click)="skipExchange()"
            class="one3d-lhs-config-btn one3d-lhs-config-left-btn"
            expand="full"
            fill="solid"
          >
          {{'CAR_EXCHANGE.SKIP' | translate}}
          </ion-button>
        </ion-col>
        <ion-col class="ion-no-padding" size="6">
          <ion-button
            class="one3d-lhs-config-btn one3d-lhs-config-right-btn"
            expand="full"
            (click)="addExchange()"
          >
          {{'CAR_EXCHANGE.ADD_TO_SUMMARY' | translate}}
          </ion-button>
        </ion-col>
      </ion-row>
    </div>
  </div>
</ion-content>
<!-- </div> -->
<!--one3d-car-exchange-wrapper ends here-->
